import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../api.service';
import { ExtratoEstoqueResponseDTO } from '../../models/estoque/extrato-estoque.model';

@Injectable({ providedIn: 'root' })
export class EstoqueService {

  constructor(private apiService: ApiService) {}

  get(url: string, data?: any): Observable<ExtratoEstoqueResponseDTO> {
    const queryParams = this.apiService.buildQueryParams(data);
    const path = queryParams ? `${url}?${queryParams}` : url;
    return this.apiService.read<ExtratoEstoqueResponseDTO>(path);
  }
}
